export default __webpack_public_path__ + "static/countdown_siri_2-adbbd3f6f143929e417c6ee520bb7532.png";